import React, { lazy, Suspense, useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./Providers/AuthProvider/AuthProvider";
import { ThemeProvider, useTheme } from "./components/Layout/ThemeContext/ThemeContext";
import WebLazyLoader from "./assets/LoaderMain/WebDesktopoutline.mp4"; // Path to your video
import MobileDesktopoutline from "./assets/LoaderMain/mobileLoader/MobileDesktopoutline.mp4";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import "./App.css";

import AdminLayout from "../src/components/Layout/Admin/Layout/AdminLayout";
import DefaultLayout from "./components/Layout/DefaultLayout";
import UserActivation from "../src/components/email/UserActivation";
import RecaptchaGenerator from "./Providers/Captchaservice/RecaptchaGenerator";
import loadAttachments from "./Providers/MediaProvider/MediaLoader";

// Splash Video Loader
// const SplashVideoLoader = ({ onFinish }) => {
//   const [isMobile, setIsMobile] = useState(false);

//   useEffect(() => {
//     // Function to detect screen size
//     const handleResize = () => {
//       setIsMobile(window.innerWidth <= 768); // Adjust breakpoint as needed
//     };

//     // Initial check
//     handleResize();

//     // Add resize event listener
//     window.addEventListener("resize", handleResize);

//     // Cleanup on component unmount
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   return (
//     <div className="fixed inset-0 flex items-center justify-center">
//       <video
//         src={isMobile ? MobileDesktopoutline : WebLazyLoader} // Conditional video source
//         autoPlay
//         playsInline
//         preload="auto"
//         muted
//         className="w-full h-full object-cover" // Ensure full screen
//         onEnded={onFinish} // Trigger when the video finishes
//       >
//         Your browser does not support the video tag.
//       </video>
//     </div>
//   );
// };

const SplashVideoLoader = ({ onFinish }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Mobile screen detection
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleVideoError = () => {
    triggerManualPlay(); // Try to trigger play manually if video fails to load
  };

  const triggerManualPlay = () => {
    const videoElement = document.getElementById("videoPlayer");
    if (videoElement) {
      videoElement.play().then(() => {
        setIsVideoPlaying(true); // Video starts playing
      }).catch(() => {
        // No error message, just fail silently
      });
    }
  };

  useEffect(() => {
    if (!isVideoPlaying) {
      const videoElement = document.getElementById("videoPlayer");
      // Try to play the video if it's not playing
      if (videoElement && videoElement.paused) {
        videoElement.play().then(() => {
          setIsVideoPlaying(true); // Video is playing now
        }).catch(handleVideoError); // Fallback if it fails to play
      }
    }
  }, [isVideoPlaying]);

  return (
    <div className="fixed inset-0 flex items-center justify-center">
      <video
        id="videoPlayer"
        src={isMobile ? MobileDesktopoutline : WebLazyLoader}
        autoPlay
        playsInline
        preload="auto"
        muted
        className="w-full h-full object-fill mobile_m_360:object-cover"
        onEnded={onFinish} // Trigger on video end
        onError={handleVideoError} // Handle errors
      >
        Your browser does not support the video tag.
      </video>
    </div>
  );
};


const App = () => {
  const [isMediaLoaded, setIsMediaLoaded] = useState(false); // Track media loading
  const [isVideoFinished, setIsVideoFinished] = useState(false);
  // const currentLocation = useLocation();

  const Site_key = process.env.REACT_APP_SITE_KEY;
  // const { setMediaItems } = useAuth();

  // useEffect(() => {
  //   // Load media items before splash video
  //   const loadMediaItems = async () => {
  //     const mediaData = await CurrentLocationPopup(); // Fetch media items
  //     if (mediaData) {
  //       setMediaItems(mediaData); // Update media items in the context
  //     }
  //     console.log("Initial media items loaded.");
  //     setIsMediaLoaded(true); // Indicate media loading is complete
  //   };

  //   loadMediaItems();
  // }, [setMediaItems]);

  // if (!isMediaLoaded) {
  //   return <div>Loading initial media...</div>; // Fallback UI while media is loading
  // }
  // const isCaptchaPage = currentLocation.pathname.includes("/get-captcha-token");

  // if (!isVideoFinished && !isCaptchaPage) {
  //   return <SplashVideoLoader onFinish={() => setIsVideoFinished(true)} />;
  // }

  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <GoogleReCaptchaProvider reCaptchaKey={Site_key}>
            <MainRoutes />
          </GoogleReCaptchaProvider>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
};

const MainRoutes = () => {
  const location = useLocation();
  const { role, setMediaItems, ispopupLoader, setIsPopupLoader } = useAuth();
  const [isVideoFinished, setIsVideoFinished] = useState(false);
  const currentLocation = useLocation();
  const [isMediaLoaded, setIsMediaLoaded] = useState(false);
 

  const isCaptchaPage = currentLocation.pathname.includes("/get-captcha-token");

 

  useEffect(() => {
    // Define the interval function
    loadMediaItems();
  }, []);

  const loadMediaItems = async () => {
    try {
      const mediaData = await loadAttachments();
      if(mediaData){
        setMediaItems(mediaData.Media);
      }; // Fetch media items
      // const attachmentStream = loadAttachments(); // Call the async generator function

      // for await (const batch of attachmentStream) {
      //   setMediaItems((prev) => [...prev, ...batch.Media]); // Append new results to the existing state
      // }
      // if (mediaData.status === true) {
      //   setMediaItems(mediaData.Media); // Update media items in the context
      // }else{
      //   setIsPopupLoader(false)
      // }
      console.log("Initial media items loaded.");
    } catch (error) {
      console.error("Error loading media items:", error);
      setIsPopupLoader(false)
     } //finally {
    //   setIsMediaLoaded(true); // Indicate media loading is complete
    // }
  };

  if (!isVideoFinished && !isCaptchaPage) {
    return <SplashVideoLoader onFinish={() => setIsVideoFinished(true)} />;
  }
  
  
  console.log("Role App js:", role);

  return (
    <Routes>
      <Route
        path={`/${process.env.REACT_APP_BASE_URL}`}
        element={<DefaultLayout role={role} />}
      >
        <Route
          path=":LayerId/:objectid"
          element={<DefaultLayout role={role} />}
        />
      </Route>
      <Route path="/admin" element={<AdminLayout role={role} />} />
      <Route
        path={`/${process.env.REACT_APP_BASE_URL}/activate/:userId`}
        element={<UserActivation />}
      />
      <Route
        path={`/${process.env.REACT_APP_BASE_URL}/get-captcha-token`}
        element={<RecaptchaGenerator />}
      />
      {/* Catch-All Redirect */}
      <Route
        path="*"
        element={
          <Navigate
            to={`/${process.env.REACT_APP_BASE_URL}`}
            state={{ from: location }}
            replace
          />
        }
      />
    </Routes>
  );
};

export default App;
